export default [
    {
        path: '/chat',
        name: 'chat',
        component: () => import('../views/chat/ChatsView.vue'),
        meta: {
            requiresAuth: true,
        },
    },
]
